export default __webpack_public_path__ + "static/icon-24-3-64d8e1056b1b7db06e7c29948a72ebcb.png";